const saveUTMTags = () => { const searchParams = new URL(window.location.href).searchParams || []; const utmDict = {}; searchParams.forEach(function (val, key) { if (key.startsWith("utm_"))
    utmDict[key] = val; }); if (Object.keys(utmDict).length > 0) {
    console.log("saving utm tags:", utmDict);
    window.localStorage.setItem("utm_tags", JSON.stringify(utmDict));
} };
const getUTMTags = () => { let tagsJson = window.localStorage.getItem("utm_tags"); if (tagsJson) {
    return JSON.parse(tagsJson);
} return; };
export { saveUTMTags, getUTMTags };
